module.exports = __webpack_public_path__ + "static/media/google.2380ea56.svg";